/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  MockUniswapV3Pool,
  MockUniswapV3PoolInterface,
} from "../../../contracts/mock/MockUniswapV3Pool";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "fee",
    outputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint24",
        name: "__fee",
        type: "uint24",
      },
    ],
    name: "setFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint160",
        name: "__sqrtPriceX96",
        type: "uint160",
      },
    ],
    name: "setSqrtPriceX96",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "__tickSpacing",
        type: "int24",
      },
    ],
    name: "setTickSpacing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "__token0",
        type: "address",
      },
    ],
    name: "setToken0",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "__token1",
        type: "address",
      },
    ],
    name: "setToken1",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "slot0",
    outputs: [
      {
        internalType: "uint160",
        name: "sqrtPriceX96",
        type: "uint160",
      },
      {
        internalType: "int24",
        name: "tick",
        type: "int24",
      },
      {
        internalType: "uint16",
        name: "observationIndex",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "observationCardinality",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "observationCardinalityNext",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "feeProtocol",
        type: "uint8",
      },
      {
        internalType: "bool",
        name: "unlocked",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tickSpacing",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token0",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token1",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type MockUniswapV3PoolConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MockUniswapV3PoolConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MockUniswapV3Pool__factory extends ContractFactory {
  constructor(...args: MockUniswapV3PoolConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<MockUniswapV3Pool> {
    return super.deploy(overrides || {}) as Promise<MockUniswapV3Pool>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): MockUniswapV3Pool {
    return super.attach(address) as MockUniswapV3Pool;
  }
  override connect(signer: Signer): MockUniswapV3Pool__factory {
    return super.connect(signer) as MockUniswapV3Pool__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockUniswapV3PoolInterface {
    return new utils.Interface(_abi) as MockUniswapV3PoolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockUniswapV3Pool {
    return new Contract(address, _abi, signerOrProvider) as MockUniswapV3Pool;
  }
}
